// - Basic settings - //

  // server
  export const API_URL = 'https://api.frydek-mistek.qtcloud.cz';

  // Google maps api key
  export const GOOGLE_API_KEY = 'AIzaSyCFn5kJ0M9ANeXrgVLgOiQLgCdetZgJGXo';

  // google recapcha v2
  export const CAPRCHA_CLIENT_KEY = '6LchWxYUAAAAAHS5JBSMFlSP3Fu-uHNr47WYzU0W';

  // title
  export const APP_TITLE = 'Rezervační systém';

  // single office mode
  export const SINGLE_OFFICE_MODE = false;

  // graph statistics
  // - default: month or year 
  export const STATS_DEFAULT_SETTING = 'year';
  // - if switching is bad idea
  export const STATS_SHOW_DATE_SWITCH = true;

// -------------------- //


// ~ Colors ~ //

  // color 1 
  //  - main color in header and selected button
  export const COLOR_1 = '#00264a';
  export const COLOR_1_BORDER_BOTTOM = '#00264a';
  export const COLOR_1_BORDER_LEFT = '#00264a';

  // color 2
  // - color in header under logo
  export const COLOR_2 = '#0099cf';
  export const COLOR_2_BORDER_BOTTOM = '#1895c1';
  export const COLOR_2_BORDER_RIGHT = '#0099cf';

  // color 3
  //  - side panel color
  export const COLOR_3 = '#00264a';
  export const COLOR_3_BORDER_RIGHT = '#00264a';

// -------------------- //
